import { formatMoney } from '../components/utilities';

// ===============================================================
// Ações referente ao cart_drawer e ao carrinho de produtos
// ===============================================================
const HeaderCart = {
  selector: '[data-cart-count]',
  attr: '[data-cart-count-attr]',
  text: '[data-cart-item-text]',

  getCartItens: async function() {
    try {
      const itens = await $.ajax({
        url: '/carrinho/itens',
        type: 'GET',
        dataType: 'text',
      })

      return itens;

    } catch (error) {
      console.error('Erro ao buscar a quantidade de produtos do carrinho');
      console.error(error);
    }
  },

  updateCartCount: async function(_itemsCount = null) {
    let items = _itemsCount;
    if (_itemsCount == null) {
      items = await this.getCartItens();
    }

    $(this.attr).data('cart-count-attr', items);
    $(this.attr).attr('data-cart-count-attr', items);

    $(this.attr).html(items);
    $(this.text).html(items);
  },
  
  show: function () {
    return window.componentCartDrawer.open()
  },

  updateInstallments: function () {
    const cartDrawer = document.querySelector('#component-cart-drawer-root');
    
    const observer = new MutationObserver(mutation => {
      if (!cartDrawer.querySelector('.cart-drawer-installments')) return;

      let installmentsEl = cartDrawer.querySelector('.cart-drawer-installments');
      let priceEl = installmentsEl.parentElement;
      let tempEl = priceEl.cloneNode(true);
      tempEl.querySelector('span').remove();

      let price = tempEl.innerText;
      if (price) {
        let value = Number(price.replace('R$ ', '').replace(',', '.'));
        if (installmentsEl.innerHTML != `ou 3x de ${formatMoney(value / 3)}`) installmentsEl.innerHTML = `ou 3x de ${formatMoney(value / 3)}`;
      }
    });
    observer.observe(cartDrawer, { attributes: true, childList: true, subtree: true });
  },

  init: function() {
    this.updateCartCount();
    this.updateInstallments();
  }
};

export default HeaderCart;
